import styled from 'styled-components';

export const StyledBasicDateTimePicker = styled.div``;
